import React from 'react';

const NotFound = () => <h2>صفحه مورد نظر پیدا نشد!</h2>;

export default NotFound;
